import { Injectable } from '@angular/core';
import { Onderneming } from '../models/Onderneming';
import { Vaa } from '../models/Vaa';
import { User } from '../models/User';
import { Cash4Bike } from '../models/Cash4Bike';
import { AanwerfSimulator } from '../models/AanwerfSimulator';
import { HolidayValue } from '../models/HolidayValue';
import { CustomLink} from '../models/CustomLink';
@Injectable({
  providedIn: 'root'
})
export class DataService {

  public onderneming: Onderneming;
  public vaa: Vaa;
  public user:User;
  public adminVanOnderneming: string;
  public aanwerfSimulator: AanwerfSimulator;
  public cash4Bike: Cash4Bike;
  public holidayValue: HolidayValue;
  public customLink: CustomLink;

  ngOnInit(): void {
    // if(this.onderneming.naam != null || this.onderneming.naam != undefined)
    localStorage.setItem('onderneming', JSON.stringify(this.onderneming.naam));
  }
  setOnderneming(o: Onderneming)
  {
    this.onderneming = o;
  }

  getOnderneming()
  {
    return this.onderneming;
  }

}
